import { createSelector } from 'reselect'
import { getAttrCount } from '../utils/productionstatus'
import { initialState } from '../reducers/productionstatusfilters'

const _getProuductionStatusStats = state => {
  // get all the levels with stats (an array of level objects)
  const productionStatusLevels = state.productionstatus.items
  // filter out all the courses that have no levels and iterate through each mock course
  return state.mockcourses.items
    .filter(mc => mc.mock_levels.length > 0)
    .map(mc => {
      // for each mock course, map through each of their levels and find all the associated ones from the production status endpoint
      const courseLevels = mc.mock_levels.map(l => {
        const associatedProductionStatusLevel = productionStatusLevels.find(
          psl => psl.mock_level_id === l.id
        )
        // need to see if we found an associated level. if so, add the other data, and pass in all the other data. if not, construct one with zero counts and add the other data
        return associatedProductionStatusLevel
          ? {
              ...associatedProductionStatusLevel,
              name: l.name,
              number: l.number,
              sort_order: l.sort_order,
              master: l.mastery
            }
          : {
              name: l.name,
              mock_level_id: l.id,
              number: l.number,
              draft_count: 0,
              published_count: 0,
              quality_review_count: 0,
              rejected_count: 0,
              total_count: 0,
              internal_review_count: 0,
              copy_edit_count: 0,
              sort_order: l.sort_order,
              master: l.mastery
            }
      })
      // return the formatted course with all levels counts and levels
      return {
        course_name: mc.name,
        course_id: mc.id,
        color: mc.color,
        course_levels: courseLevels,
        total_count: courseLevels.reduce(getAttrCount('total_count'), 0),
        published_count: courseLevels.reduce(
          getAttrCount('published_count'),
          0
        ),
        quality_review_count: courseLevels.reduce(
          getAttrCount('quality_review_count'),
          0
        ),
        rejected_count: courseLevels.reduce(getAttrCount('rejected_count'), 0),
        draft_count: courseLevels.reduce(getAttrCount('draft_count'), 0),
        internal_review_count: courseLevels.reduce(
          getAttrCount('internal_review_count'),
          0
        ),
        copy_edit_count: courseLevels.reduce(getAttrCount('copy_edit_count'), 0)
      }
    })
}

const _hasActiveFilters = state => {
  return (
    JSON.stringify(initialState) !==
    JSON.stringify(state.productionstatusfilters)
  )
}

export const getProuductionStatusStats = createSelector(
  [_getProuductionStatusStats],
  productionStatusCounts => {
    return productionStatusCounts
  }
)

export const hasActiveFilters = createSelector([_hasActiveFilters], retVal => {
  return retVal
})



// WEBPACK FOOTER //
// ./src/selectors/productionstatus.js